import React, { Component } from 'react'
import { connect } from 'react-redux'
import ValidatorContainer from './ValidatorContainer'
import UserContainer from './UserContainer'

/**
 * InvoiceContainer — feature-gated entry point for the Invoice module.
 *
 * Renders ValidatorContainer (manager view) or UserContainer (salesperson view)
 * depending on `campaignUser.canInvoiceValidate`.
 */
class InvoiceContainer extends Component {
  render() {
    const { campaign, campaignUser } = this.props
    const isValidator = campaignUser && campaignUser.canInvoiceValidate

    return isValidator
      ? <ValidatorContainer campaign={campaign} />
      : <UserContainer campaign={campaign} />
  }
}

const mapStateToProps = (state) => ({
  campaign: state.campaignReducer.campaign,
  campaignUser: state.balanceReducer.campaignUser,
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceContainer)
